import { client } from "../../../api/client";

export const fetchItemLookupByFilter = async (body) => {
    console.log('fetchItemLookupByFilter')
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        var startIndex = (body.pageNumber * body.pageSize) - body.pageSize
        var endIndex = (body.pageNumber * body.pageSize)

        var items = require("./_local/_itemLookupData.json").itemLookupItems;

        console.log('items', items)

        if (body.itemLookupTypeId) {
            items = items.filter(x => x.itemLookupTypeId === body.itemLookupTypeId)
        }

        if (body.itemLookupTagId) {
            items = items.filter(x => x.itemLookupTags.some(y => y.tagId === body.itemLookupTagId))
        }
        console.log('items filtered', items)

        return { itemLookupItems: items.slice(startIndex, endIndex), totalRecords: items.length }
    } else {
        try {
            const response = await client.post(process.env.REACT_APP_GATEWAY_URI, "iquoteapi/itemlookup/filter", body);
            return response.data;
        } catch (error) {
            console.error("Error fetching item lookup:", error);
            return [];
        }
    }
};

export const hasItemLookupType = async (itemLookupTypeId) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        return false;
    } else {
        try {
            const response = await client.get(process.env.REACT_APP_GATEWAY_URI, `iquoteapi/itemlookup/hasitemlookuptype/${itemLookupTypeId}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching has item lookup type:", error);
            return [];
        }
    }
};

export const checkSupplierConstraints = async (supplierId) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        return false;
    } else {
        try {
            const response = await client.get(process.env.REACT_APP_GATEWAY_URI, `iquoteapi/itemlookup/checksupplierconstraints/${supplierId}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching Check Supplier Constraints:", error);
            return [];
        }
    }
};

export const fetchItemLookupCustomAttributes = async () => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        return [];
    } else {
        try {
            const response = await client.get(process.env.REACT_APP_GATEWAY_URI, "iquoteapi/itemlookup/customattributes");
            return response.data;
        } catch (error) {
            console.error("Error fetching item lookup custom attributes:", error);
            return [];
        }
    }
};


export const createItemLookup = async (body) => {
    if (process.env.REACT_APP_USELOCALDATA === "false") {
        try {
            return await client.post(process.env.REACT_APP_GATEWAY_URI, 'iquoteapi/itemlookup', body);
        } catch (error) {
            console.error("Error creating item lookup:", error);
            return [];
        }
    } else {
        return { "data": { newId: Math.floor(Math.random() * 100000) } };
    }
};

export const createItemLookups = async (body) => {
    if (process.env.REACT_APP_USELOCALDATA === "false") {
        try {
            return await client.post(process.env.REACT_APP_GATEWAY_URI, 'iquoteapi/itemlookup/bulk', body);
        } catch (error) {
            console.error("Error creating item lookups:", error);
            return [];
        }
    } else {
        return { "data": { newId: Math.floor(Math.random() * 100000) } };
    }
};

export const updateItemLookup = async (id, body) => {
    if (process.env.REACT_APP_USELOCALDATA === "false") {
        try {
            return await client.put(process.env.REACT_APP_GATEWAY_URI, `iquoteapi/itemlookup/${id}`, body);
        } catch (error) {
            console.error("Error updating item lookup:", error);
            return [];
        }
    }
};

export const updateItemLookups = async (body) => {
    if (process.env.REACT_APP_USELOCALDATA === "false") {
        try {
            return await client.put(process.env.REACT_APP_GATEWAY_URI, 'iquoteapi/itemlookup/bulk', body);
        } catch (error) {
            console.error("Error updating item lookups:", error);
            return [];
        }
    } else {
        return { "data": { newId: Math.floor(Math.random() * 100000) } };
    }
};

export const fetchItemLookup = async (id) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        try {
            // Load local data and filter by ids
            const items = require("./_local/_itemLookupData.json").itemLookupItems || [];
            return items.find(x => x.id === id);
        } catch (error) {
            console.error("Error fetching item lookup (local):", error);
            return [];
        }
    } else {
        try {
            const response = await client.get(
                process.env.REACT_APP_GATEWAY_URI,
                "iquoteapi/itemlookup/" + id
            );
            return response.data;
        } catch (error) {
            console.error("Error fetching item lookup:", error);
            return [];
        }
    }
};

export const fetchItemLookupBatch = async (ids) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        try {
            if (!Array.isArray(ids) || ids.length === 0) return [];

            // Load local data and filter by ids
            const items = require("./_local/_itemLookupData.json").itemLookupItems || [];
            const set = new Set(ids);
            return items.filter(x => set.has(x.id));
        } catch (error) {
            console.error("Error fetching item lookup batch (local):", error);
            return [];
        }
    } else {
        try {
            // Calls your new controller: [HttpPost("batch")]
            const response = await client.post(
                process.env.REACT_APP_GATEWAY_URI,
                "iquoteapi/itemlookup/batch",
                ids
            );
            return response.data;
        } catch (error) {
            console.error("Error fetching item lookup batch:", error);
            return [];
        }
    }
};
